(function() { window.GUID_1d652fde_6e23_4342_bb90_73b71ee8b8c0 = { getGuid: function() { return "1d652fde-6e23-4342-bb90-73b71ee8b8c0"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Ready({
                        selector: "body",
                        childSelector: ".accordion-stats-summary",
                        callback: (accordion, e) => {
                            const isStatWallV2 = CS.DOM.$body.hasClass("controller-statswallv2");
                            if (!isStatWallV2)
                                return;
                            const $content = accordion.$Content.find(".inner-content");
                            if (!$content.length)
                                return;
                            let $statsGridHiddenStringifiedColumnsStatFields = $(".stats-grid-hidden-stringified-columns-stat-fields");
                            if (!$statsGridHiddenStringifiedColumnsStatFields.length)
                                return;
                            $statsGridHiddenStringifiedColumnsStatFields =
                                $statsGridHiddenStringifiedColumnsStatFields.first();
                            const statsGridHiddenStringifiedColumnsStatFields = $statsGridHiddenStringifiedColumnsStatFields.val() || "";
                            if (!statsGridHiddenStringifiedColumnsStatFields ||
                                typeof statsGridHiddenStringifiedColumnsStatFields !== "string")
                                return;
                            const statFields = statsGridHiddenStringifiedColumnsStatFields
                                .split(",")
                                .map((x) => x.trim())
                                .filter((x) => x);
                            if (!statFields.length)
                                return;
                            // for (let i = 0; i < statFields.length; i++) {
                            //   const $statValue = $content.find(
                            //     `.stat-value[data-stat-field-id="${statFields[i]}"]`
                            //   );
                            //   if (!$statValue.length) continue;
                            //   $statValue.css({
                            //     order: i + 1,
                            //   });
                            //   if (i === 0) {
                            //     $statValue.addClass("first");
                            //   }
                            // }
                            // Instead of attribuiting the order, we just sort the stat values
                            const $statValues = $content.find(".stat-value");
                            if (!$statValues.length)
                                return;
                            const $statValuesSorted = $statValues
                                .toArray()
                                .sort((a, b) => {
                                let aOrder = statFields.indexOf($(a).data("stat-field-id"));
                                if (aOrder <= -1)
                                    aOrder = 9999;
                                let bOrder = statFields.indexOf($(b).data("stat-field-id"));
                                if (bOrder <= -1)
                                    bOrder = 9999;
                                return aOrder - bOrder;
                            })
                                .map((x) => $(x).clone());
                            $statValues.remove();
                            $content.append($statValuesSorted);
                        },
                    });
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=section.ready.js.map
